<template>
    <div class="ad-package-wrap">
        <breadcrumb main-name="广告包更新" :breadcrumbList="breadcrumbList"></breadcrumb>
        <div class="content">
            <div class="download-package-wrap">
                <div class="download-package-box" @click="downloadPackage">
                    <div class="download-package">
                        <div v-if="!success">
                            <span class="download-img"></span>
                            <p>点击下载广告包</p>
                        </div>
                        <div v-else>
                            <span class="download-img success"></span>
                            <p>广告包提取成功</p>
                        </div>
                        <ul>
                            <li>广告包版本：{{packageInfo.packageVersion}}</li>
                            <li>文件大小：{{packageInfo.packageSize>=1024?(packageInfo.packageSize/1024).toFixed(2)+"GB":packageInfo.packageSize+"MB"}}</li>
                            <li>最近下载时间：{{packageInfo.downloadTime}}</li>
                            <li>最新更新时间：{{packageInfo.createTime}}</li>
                        </ul>
                    </div>
                </div>
                <div class="tip">
                    <a-icon type="info-circle" theme="filled"/>
                    本次广告包涉及 <i>{{reservedFields.communityCount}} </i>个小区共 <i>{{reservedFields.devCount}}</i> 个广告机
                    <span @click="downloadCaseList">下载任务单</span>
                </div>
                <div class="address-table">
                    <a-table :columns="columns" :dataSource="adList" :pagination="false"></a-table>
                    <div class="page-wrap">
                        <a-pagination
                                :pageSizeOptions="pageSizeOptions"
                                :total="total"
                                showSizeChanger
                                showQuickJumper
                                :pageSize="pageSize"
                                v-model="current"
                                @showSizeChange="onShowSizeChange"
                                @change="changePage"
                        >
                        </a-pagination>
                    </div>
                </div>
            </div>
            <div class="download-table">
                <h3>下载记录</h3>
                <div class="table-wrap">
                    <a-table :columns="downloadColumns" :dataSource="downloadList" :pagination="false"></a-table>
                    <div class="page-wrap">
                        <a-pagination
                                :pageSizeOptions="DLpageSizeOptions"
                                :total="DLtotal"
                                showSizeChanger
                                showQuickJumper
                                :pageSize="DLpageSize"
                                v-model="DLcurrent"
                                @showSizeChange="onShowSizeChangeDL"
                                @change="changePageDL"
                        >
                        </a-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import breadcrumb from '../common/Breadcrumb.vue'
    import api from '../../commomFun/api.js'
    import timeFormat from '../../commomFun/timeFormat';
    import axios from 'axios';

    export default {
        name: "adPackage",
        components: {
            breadcrumb
        },
        inject: ['reload'],
        data() {
            return {
                // 面包屑
                breadcrumbList: [
                    {
                        name: '广告包更新',
                        path: '/adPackage'
                    }
                ],
                packageInfo: {
                    packageVersion: '-',
                    packageSize: '-',
                    downloadTime: '-',
                    createTime: '-',
                    packageId: 0,
                },
                reservedFields: {
                    communityCount: 32,
                    devCount: 132,
                },
                success: false,
                columns: [
                    {
                        dataIndex: 'key',
                        title: '序号',
                        key: 'key'
                    },
                    {
                        dataIndex: 'city',
                        title: '城市',
                        key: 'city'
                    }, {
                        title: '区域',
                        dataIndex: 'area',
                        key: 'area'
                    }, {
                        title: '小区',
                        dataIndex: 'community',
                        key: 'community'
                    }, {
                        title: '广告机名称',
                        key: 'adMechineName',
                        dataIndex: 'adMechineName'
                    }, {
                        title: '设备ID',
                        key: 'mechineID',
                        dataIndex: 'mechineID'
                    }, {
                        title: '地址',
                        key: 'address',
                        dataIndex: 'address'
                    }],
                adList: [{
                    key: '',
                    city: '',
                    area: '',
                    community: '',
                    address: '',
                    adMechineName: '',
                    mechineID: '',
                }],
                downloadColumns: [
                    {
                        dataIndex: 'key',
                        title: '序号',
                        key: 'key'
                    },
                    {
                        dataIndex: 'packageVersion',
                        title: '广告包版本',
                        key: 'packageVersion'
                    }, {
                        title: '文件大小',
                        dataIndex: 'packageSize',
                        key: 'packageSize'
                    }, {
                        title: '公司',
                        dataIndex: 'companyName',
                        key: 'companyName'
                    }, {
                        title: '操作人',
                        key: 'handler',
                        dataIndex: 'handler'
                    }, {
                        title: '操作人角色',
                        key: 'handlerRole',
                        dataIndex: 'handlerRole'
                    }, {
                        title: '下载时间',
                        key: 'downloadTime',
                        dataIndex: 'downloadTime'
                    }],
                downloadList: [{
                    key: '1',
                    packageVersion: '---',
                    packageSize: '---',
                    companyName: '---',
                    handler: '---',
                    handlerRole: '---',
                    downloadTime: '---',
                }],
                pageSizeOptions: ['10', '20', '30', '40'],
                current: 1,
                pageSize: 10,
                total: 0,
                DLpageSizeOptions: ['10', '20', '30', '40'],
                DLcurrent: 1,
                DLpageSize: 10,
                DLtotal: 0,

            }
        },
        methods: {
            changePage(page, pageSize) {
                // console.log(page, pageSize);
                this.pageSize = pageSize;
                this.current = page;
                this.getAdlist()
            },
            onShowSizeChange(current, pageSize) {
                // console.log(current, pageSize);
                this.pageSize = pageSize;
                this.getAdlist()
            },
            changePageDL(page, pageSize) {
                // console.log(page, pageSize);
                this.DLpageSize = pageSize;
                this.DLcurrent = page;
                this.getDownloadList()
            },
            onShowSizeChangeDL(current, pageSize) {
                console.log(current, pageSize);
                this.DLpageSize = pageSize;
                this.getDownloadList()
            },
            //下载任务单
            downloadCaseList() {
                //下载一个Excel，命名规则：“任务单_广告包版本”例：任务单_广州亲粤邻 20190513
                let packageId = this.packageInfo.packageId;
                // console.log(axios.defaults.baseURL);
                window.location.href = axios.defaults.baseURL + '/package/downloadTaskList?packageId=' + packageId

            },
            //下载广告包
            downloadPackage() {
                if (!this.success) {
                    let that = this;
                    this.$confirm({
                        title: '确认要下载该广告包吗',
                        content: '本次广告包版本为 ' + that.packageInfo.packageVersion + '，文件大小 ' + that.packageInfo.packageSize>=1024?(that.packageInfo.packageSize/1024).toFixed(2)+"GB":that.packageInfo.packageSize+"MB",
                        onOk() {
                            // console.log(that.packageInfo.packageUrl);
                            window.location.href = that.packageInfo.packageUrl;
                            that.success = true;
                            that.addDownload('ok');
                            setTimeout(function () {
                                that.reload()
                            },10000);

                        },
                        onCancel() {
                            console.log('Cancel');
                            // that.addDownload('cancel')
                        },
                        class: 'test',
                    });
                }
            },
            //下载事件上报
            addDownload(type) {
                let info = {}
                if (type == 'ok') {
                   info = {
                       packageId: this.packageInfo.packageId,
                       status:1 //1成功2失败
                   }
                } else {
                    info = {
                        packageId: this.packageInfo.packageId,
                        status:2 //1成功2失败
                    }
                }
                console.log(info);
                api.postApi('/package/addDownload', info).then(res => {
                    if (res.data.code == 200) {
                        //上报成功
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //下载记录列表
            getDownloadList() {
                let info = {
                    pageNum: this.DLcurrent,
                    pageSize: this.DLpageSize,
                };
                api.getApi('/package/getDownloadList',info).then(res => {
                    if (res.data.code == 200) {
                        let result = res.data.data.list;
                        this.DLtotal = res.data.data.total;
                        let arr = [];
                        let packageSize = '';
                        for (let i = 0; i < result.length; i++) {
                            packageSize = (result[i].packageSize / 1024 / 1024 ).toFixed(2)
                            let obj = {
                                key: i+1,
                                packageVersion: result[i].packageVersion?result[i].packageVersion:'---',
                                packageSize: packageSize>=1024?(packageSize/1024).toFixed(2)+"GB":packageSize+"MB",
                                companyName: result[i].companyName?result[i].companyName:'---',
                                handler: result[i].opUsername?result[i].opUsername:'---',
                                handlerRole: result[i].opUserRule==3?'工程人员':result[i].opUserRule,
                                downloadTime: result[i].downloadTime?timeFormat.toDateTime(result[i].downloadTime):'---',
                            };
                            arr.push(obj)
                        }
                        this.downloadList = arr
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //广告包任务列表记录
            getAdlist() {
                let info = {
                    pageNum: this.current,
                    pageSize: this.pageSize,
                    packageId: this.packageInfo.packageId,
                };
                api.getApi('/package/listTaskByPage', info).then(res => {
                    if (res.data.code == 200) {
                        this.total = res.data.data.total;
                        this.reservedFields = res.data.data.reservedFields
                        let result = res.data.data.list;
                        let arr = [];
                        for (let i = 0; i < result.length; i++) {
                            let obj = {
                                key: i+1,
                                city: result[i].city?result[i].city:'---',
                                area: result[i].area?result[i].area:'---',
                                community: result[i].communityName?result[i].communityName:'---',
                                address: result[i].address?result[i].address:'---',
                                adMechineName: result[i].deviceName?result[i].deviceName:'---',
                                mechineID: result[i].devId?result[i].devId:'---',
                            };
                            arr.push(obj)
                        }
                        this.adList = arr
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //广告包信息
            getAdPackageInfo() {
                let that = this
                api.getApi('/package/getPackage').then(res => {
                    if (res.data.code === 200) {
                        let obj = {
                            packageVersion: res.data.data.packageVersion,
                            packageSize: (res.data.data.packageSize / 1024 / 1024 ).toFixed(2),
                            downloadTime: res.data.data.downloadTime,
                            createTime: res.data.data.createTime,
                            packageId: res.data.data.packageId,
                            packageUrl: res.data.data.packageUrl
                        };
                        this.packageInfo = obj
                      setTimeout(()=>{
                          that.getAdlist();
                      },200)
                    } else {
                        this.$message.error(res.data.code)
                    }
                })
            },


        },
        mounted() {
            this.getAdPackageInfo();
            this.getDownloadList();
        }
    }
</script>

<style scoped>
    .content {
        padding: 24px;
    }

    .download-package-wrap {
        padding: 32px;
        background: #fff;
    }

    .download-package {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 33px 0 25px 0;
        background: rgba(0, 0, 0, 0.02);
        border: 1px dashed rgba(0, 0, 0, 0.15);
        cursor: pointer;
    }

    .download-package:hover {
        border: 1px dashed #1890ff;
    }

    .download-package > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .download-package p {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        margin-top: 21px;
        margin-bottom: 8px;
    }

    .download-package ul {
        display: flex;
    }

    .download-package ul li {
        color: rgba(0, 0, 0, 0.43);
        border-right: 1px solid #D8D8D8;
        padding: 0 10px;
    }

    .download-package ul li {
        border-right: none;
    }

    .download-img {
        display: inline-block;
        width: 134px;
        height: 134px;
        background-size: 720px 720px !important;
        background: url(../../../public/images/cssSprite.png) no-repeat -24px -560px;
    }

    .download-img.success {
        background: url(../../../public/images/cssSprite.png) no-repeat -182px -571px;
    }

    .tip {
        width: 100%;
        height: 40px;
        background: #fff;
        line-height: 40px;
        background: rgba(230, 247, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(145, 213, 255, 1);
        padding: 0 16px;
        margin-top: 16px;
        margin-bottom: 16px;
    }

    .tip i, .tip span {
        color: #1890ff;
        font-style: normal;
    }

    .tip span {
        float: right;
        cursor: pointer;
    }

    .address-table {
        padding-bottom: 32px;
        background: #fff;
    }

    .download-table {
        margin-top: 16px;
        background: #fff;
    }

    .download-table h3 {
        height: 55px;
        line-height: 55px;
        padding-left: 32px;
        border-bottom: 1px solid #E9E9E9;
        margin-bottom: 16px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
    }


</style>